<template>
  <div class="container">
    <p v-if="inProgress">Activating</p>
    <p v-else-if="hasError">
      Link is invalid or the account has been already activated
    </p>
    <p v-else>
      Account has been activated
    </p>
  </div>
</template>

<script>

import activationLink from "@/api/activationLink";

export default {
  data () {
    return {
      inProgress: true,
      hasError: false
    }
  },
  async mounted() {
    try {
      await activationLink.get(this.$route.query.key)
    } catch (e) {
      this.hasError = true
    } finally {
      this.inProgress = false
        setTimeout(() => {
            this.$router.push('/login')
        }, 750)
    }
  }
}
</script>
